export default "__VITE_ASSET__cbbdaf26__"